import axios from "axios";
import baseURL from "./../api";
import { useSelector } from 'react-redux';


export function useUserPermission(permcode) {
    const userData = useSelector(state => state.authReducer);
    if (!userData || !userData.user || !userData.user.data || !userData.user.data.role || !userData.user.data.role.permissions)
        return false;

    const permissionArr = userData.user.data.role.permissions;
    console.log(permissionArr,"permissionArr")
    return permissionArr.some(permission => permission.permission_code === permcode);
}


export class ConfigService {
    constructor() {
        this.time = new Date().getTime();
    }

    getStates() {
        return axios.get(`${baseURL}/config/state?${this.time}`);
    }
    getCities(id) {
        return axios.get(`${baseURL}/config/cities/${id}?${this.time}`);
    }
    getIndustries() {
        return axios.get(`${baseURL}/config/industry-type?${this.time}`);
    }
    getBusinessType() {
        return axios.get(`${baseURL}/config/business-type?${this.time}`);
    }

    getCommGroups(param,customerId) {
        let url = ''
        if(customerId) {
          url =  `${baseURL}/config/drop-down/commission-groups?userType=${param}&customerId=${customerId}`
        } else {
             url =  `${baseURL}/config/drop-down/commission-groups?userType=${param}`
        }
        return axios.get(url);

    }
    getLimitGroups() {
        return axios.get(`${baseURL}/config/drop-down/limit-groups?${this.time}`);

    }

    checkUserPermission(permcode) {
        return useUserPermission(permcode);
    }

    getAdvanceFilterValues() {
        return axios.get(`${baseURL}/config/drop-down/search-advanced-filter?${this.time}`);

    }

    getAgentsDropDown(id=null) {
        return axios.get(`${baseURL}/config/drop-down/agent?${this.time}${id?"&distributorId="+id:""}`);

    }

    getMerchantDropDown() {
        return axios.get(`${baseURL}/config/drop-down/merchant?${this.time}`);

    }

    getDistributorDropDown() {
        return axios.get(`${baseURL}/config/drop-down/distributor?${this.time}`);

    }

    getAgentDropDownByDistributorId(id) {
        return axios.get(`${baseURL}/config/drop-down/distributor?${this.time}${id && "&id="+id}`);

    }

    getPayinBankingPartners() {
        return axios.get(`${baseURL}/config/drop-down/banking-partner/payin?${this.time}`);
    }

    getPayoutBankingPartners() {
        return axios.get(`${baseURL}/config/drop-down/banking-partner/payout?${this.time}`);
    }

}
export default new ConfigService();